export default __webpack_public_path__ + "static/media/3750360 2.ab13f5bd.png";